
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './khristian1.scss';






const Pkhristian1 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {





  
  
  
  

  
  return (
    <div id="id64cbc52592554645256452ae" >

      <div id="i55h" className="">
      
      <div id="id6iic" className="">
      
        <a
          target=""
          className=""
          id="ikuk3f"
          href={`/`}
        >
          
      <img
        className=""
        id="i9pt4f"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkr1t22z.png"
        alt="undefined"
      />
      
        </a>
        
      <div id="izuf7m" className="">
      
        <a
          target=""
          className=""
          id="i3mkrh"
          href={`/quienessomos`}
        >
          
      <div className="" id="ilb64w">
        <>Quiénes Somos</>
      </div>
      
        </a>
        
        <a
          target=""
          className=""
          id="ibhmfa"
          href={`/aprende`}
        >
          
      <div className="" id="il1q3h">
        <>Aprende</>
      </div>
      
        </a>
        
        <a
          target=""
          className=""
          id="i7q4zk"
          href="/#ijf0dn"
        >
          
      <div className="" id="it6im4">
        <>Preguntas</>
      <br className="" id="" />
      <>Frecuentes</>
      </div>
      
        </a>
        
        <a
          target=""
          className=""
          id="ilbw8k"
          href="/#ijn4q"
        >
          
      <div className="" id="ixd91v">
        <>Contáctanos</>
      </div>
      
        </a>
        
      </div>
      
      </div>
      
      <div id="icv7c" className="">
      
      </div>
      
      <div id="ifxad2" className="">
      
      <div id="ijzglu" className="">
      
      <div className="" id="isdsyu">
        <>¿En qué consiste una gestión activa del flujo de caja en la empresa?</>
      </div>
      
      <div id="icj91z" className="">
      
      <div className="" id="ibmtil">
        <>Para llevar a cabo una gestión activa eficiente de la liquidez de tu empresa, hay dos aspectos clave a considerar:</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      <b className="" id="ihsf9y">
        <>1.</>
      </b>
      <>  Tener información clara y completa sobre tu situación financiera actual y las opciones que ofrece el mercado financiero. Es fundamental estar bien informado para tomar decisiones informadas.</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      <b className="" id="">
        <>2. </>
      </b>
      <> Llevar </>
      <span className="" id="iz0ew9">
        <>a cabo acciones</>
      </span>
      
      <span className="" id="i4cou6">
        <>concretas</>
      </span>
      <> basadas en la información disponible. La ejecución es crucial para que cualquier negocio progrese y alcance sus metas financieras.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Para poder hacer una gestión activa eficiente de nuestros recursos, </>
      <u className="" id="">
        
      <b className="" id="i9wnay">
        <>es importante tener en cuenta cual es la información exacta que necesitamos:</>
      <br className="" id="" />
      
      </b>
      
      </u>
      
      <br className="" id="" />
      
      <p className="MsoListParagraphCxSpFirst " id="i4cneg">
        
      <b className="" id="i44ifv">
        <>     1</>
      </b>
      
      <span className="" id="iirik3">
        
      </span>
      
      <b className="gjs-selected " id="i3tghk">
        
      </b>
      
      <span className="" id="igq2ff">
        <>Construyendo y actualizando permanentemente<br />el flujo de caja de la empresa que nos permite tomar decisiones más rápidas en<br />tiempo real, pues es la clave fundamental para determinar la mejor estrategia<br />para nuestra situación actual de liquidez y aprovechar las oportunidades que se<br />nos presentan.</>
      </span>
      
      </p>
      
      <p className="MsoListParagraphCxSpFirst " id="ixrnwe">
        
    <div id="ic63m4" className="">
    
    </div>
    
      </p>
      
      <p className="MsoListParagraphCxSpMiddle " id="i1ujid">
        
      <span className="" id="">
        
      <span className="" id="i1i7hs">
        
      <span className="" id="ir3tek">
        
    <div id="" className="">
    
      <span className="" id="irnmo3">
        
      <b className="" id="">
        
      </b>
      
      </span>
      
    </div>
    
      </span>
      
      </span>
      
      </span>
      
      <b className="" id="iw0p8i">
        
      </b>
      
      <span className="" id="ijc41c">
        <>2.  </>
      </span>
      
      <span className="" id="ihpv0j">
        <>Seguimiento en tiempo real a los productos<br />financieros, generación de alarmas y la mejor estrategia entre los diferentes<br />productos que maximice nuestra rentabilidad.</>
      </span>
      
      </p>
      
      <p className="MsoListParagraphCxSpMiddle gjs-selected " id="ieal3y">
        
    <div id="iof7ez" className="">
    
    </div>
    
      </p>
      
      <p className="MsoListParagraphCxSpLast " id="">
        
    <div id="" className="">
    
    </div>
    
      </p>
      
      <p className="MsoNormal " id="">
        <>En </>
      <b className="" id="">
        <>TRET</>
      </b>
      <> te ayudamos con todo lo anterior y sabemos cómo<br />negociar con las entidades financieras, apoyando a nuestros clientes para<br />lograr mejores condiciones. </>
    <div id="" className="">
    
    </div>
    
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i5of" className="">
      
      <div id="i8lmjf" className="">
      
      <div id="im4a28" className="">
      
      <img
        className=""
        id="iteqmg"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkr5bykb.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iqpkke" className="">
      
      <div className="" id="iy8adh">
        <>Dirección</>
      </div>
      
      <div className="" id="iiauur">
        <>Bogota, Colombia</>
      </div>
      
      </div>
      
      <div id="imh7h6" className="">
      
      <div className="" id="ijoril">
        <>Correo de contacto</>
      </div>
      
      <div className="" id="ik2c1u">
        <>info@tret.com.co</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iw4n9w" className="">
      
      <div id="ianz3m" className="">
      
      </div>
      
      <div id="iufalf" className="">
      
      <div className="" id="ij1xap">
        <>Coyright©2023 TRET - Todos los derechos reservados.</>
      </div>
      
      <div id="ielirh" className="">
      
      <img
        className=""
        id="ii3z3k"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk14hfve.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="i1414e"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk14i6xh.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="it3ooa"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk14iokp.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pkhristian1);
  